import { useTranslation } from 'react-i18next';
import { InvoiceStatus, type VerifiedOrderPaymentStatus } from '@optiflow/types';
import { Badge } from '@/components/ui/Badge';

const PAYMENT_TONES: Record<VerifiedOrderPaymentStatus, 'success' | 'warning' | 'danger'> = {
  PAID: 'success',
  PARTIALLY_PAID: 'warning',
  UNPAID: 'danger',
};

/** The invoice status in the product's own words: issued, or void and kept as a record. */
export function InvoiceStatusBadge({ status }: { status: InvoiceStatus }) {
  const { t } = useTranslation();
  return (
    <Badge tone={status === InvoiceStatus.VOID ? 'danger' : 'neutral'}>
      {t(`sales.invoices.status.${status}`)}
    </Badge>
  );
}

/** The order's payment status from the canonical receivable; a cancelled order has none and says so. */
export function OrderPaymentBadge({
  status,
  orderCancelled,
}: {
  status: VerifiedOrderPaymentStatus | null;
  orderCancelled: boolean;
}) {
  const { t } = useTranslation();
  if (status === null) {
    return (
      <Badge tone="neutral">{orderCancelled ? t('sales.invoices.orderCancelled') : '—'}</Badge>
    );
  }
  return <Badge tone={PAYMENT_TONES[status]}>{t(`sales.verify.payment.${status}`)}</Badge>;
}
